import { selector } from 'recoil';
import { allValid, alwaysValid, createMultipleFieldValidationSelector, validateSchema, } from '@zurich/common/recoil';
import { partyAreaCodeSchema, partyCountryCallingCodeSchema, partyInquiryMessage, partyLocalPhoneNumberSchema, } from '../../forms';
import { loaclAreaCodeAtom, loaclCountryCallingCodeAtom, loaclPhoneNumberAtom, localCustomerRequestMessageSelector, localPartyOnlineInquiryRadioAtom, localPartyTelephoneNumberAtom, } from '../atoms/locals';
export const countryCallingCodeValidatorSelector = selector({
    key: '@zurich/contract/validation/countryCallingCode',
    get: ({ get }) => {
        const countryCallingCode = get(loaclCountryCallingCodeAtom);
        return validateSchema(partyCountryCallingCodeSchema, countryCallingCode);
    },
});
export const areaCodeValidatorSelector = selector({
    key: '@zurich/contract/validation/areaCodeLocal',
    get: ({ get }) => {
        const localAreaCode = get(loaclAreaCodeAtom);
        return validateSchema(partyAreaCodeSchema, localAreaCode);
    },
});
export const phoneNumberValidatorSelector = selector({
    key: '@zurich/contract/validation/phoneNumberLocal',
    get: ({ get }) => {
        const localPhoneNumber = get(loaclPhoneNumberAtom);
        return validateSchema(partyLocalPhoneNumberSchema, localPhoneNumber);
    },
});
export const phoneCompositeValidationSelector = selector({
    key: 'validation/local/phoneComposite',
    get: ({ get }) => allValid({
        countryCallingCode: get(countryCallingCodeValidatorSelector),
        areaCode: get(areaCodeValidatorSelector),
        phoneNo: get(phoneNumberValidatorSelector),
    }),
});
export const inquiryTextValidatorSelector = selector({
    key: '@zurich/customer-portal/validations/inquiryTextValidatorSelector',
    get: ({ get }) => {
        const text = get(localCustomerRequestMessageSelector);
        return validateSchema(partyInquiryMessage, text);
    },
});
export const isTelephoneOnlineInquirySelector = selector({
    key: '@zurich/customer-portal/validation/isTelephoneOnlineInquirySelector',
    get: ({ get }) => {
        const radioValue = get(localPartyOnlineInquiryRadioAtom);
        const localPhoneNumber = get(localPartyTelephoneNumberAtom);
        return radioValue === 'email'
            ? alwaysValid(true)
            : validateSchema(partyLocalPhoneNumberSchema, localPhoneNumber);
    },
});
export const localUserOnlineInquiryStepValidationSelector = createMultipleFieldValidationSelector('@zurich/customer-portal/validation/onlineInquiry', {
    inquiryTextValidatorSelector,
    isTelephoneOnlineInquirySelector,
});
